var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGutters2Story(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gutters2story",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231.89 176.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "122.64 55.52 62.44 2.07 19.43 45.71 9.76 55.52 9.76 175.03 220.39 175.03 220.39 55.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "19.11 15.25 19.11 45.71 34.37 30.56 34.37 15.25 19.11 15.25"
  })), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "73.07 11.51 230.39 11.51 230.39 55.52 122.64 55.52 122.64 173.35"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 28.49,
    y: 119.85,
    width: 31.92,
    height: 55.18
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 74.16,
    y: 119.85,
    width: 31.92,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 74.16,
    y: 69.13,
    width: 31.92,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 145.36,
    y: 69.13,
    width: 54.23,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 28.49,
    y: 69.13,
    width: 31.92,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 145.36,
    y: 119.85,
    width: 54.23,
    height: 54.23
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 146.14,
    y1: 138.57,
    x2: 199.59,
    y2: 138.57
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 146.14,
    y1: 156.35,
    x2: 199.59,
    y2: 156.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 1.08,
    y1: 64.46,
    x2: 10.49,
    y2: 54.78
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 131.62,
    y1: 64.8,
    x2: 122.21,
    y2: 55.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutters2Story);
export default __webpack_public_path__ + "static/media/gutters2story.feea5737f4b13418dc69defa561e2c68.svg";
export { ForwardRef as ReactComponent };